import { ChevronUpIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { cn } from '@/services/utils';

import { Icon } from '../Icon';
import LabelPanel from '../LabelPanel/LabelPanel';

export type DropdownOption = {
    label: string;
    value: string;
};

export interface ButtonDropdownProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon?: React.ElementType;
    titleOne: string;
    titleTwo?: string;
    isDisabled?: boolean;
    titleOneHasMaxWidth?: boolean;
    isOpen?: boolean;
};

const ButtonDropdown = React.forwardRef<HTMLButtonElement, ButtonDropdownProps>(({
    icon,
    titleOne,
    titleTwo,
    isDisabled = false,
    titleOneHasMaxWidth = false,
    isOpen = false,
    ...props
}, ref) => {

    const baseClasses = [
        'tw-relative',
        'tw-border-primary',
        'tw-flex',
        'tw-items-center',
        'tw-justify-between',
        'tw-w-auto',
        'tw-h-9',
        'lg:tw-h-10',
        'tw-rounded',
        'tw-border',
        'tw-border-solid',
        'tw-bg-fill-primary',
        'tw-transition-colors',
        'tw-ease-out',
        'tw-duration-100',
        'tw-gap-4',
        'tw-px-3',
        'tw-py-2',
    ];

    const stateClasses = [
        isDisabled && 'tw-text-t-inactive tw-cursor-not-allowed',
        isOpen && !isDisabled && 'tw-border-primary-active',
        isOpen && !isDisabled && 'focus:tw-ring-0',
        !isDisabled && 'tw-cursor-pointer',
        !isOpen && !isDisabled && 'hover:tw-border-primary-hover',
        'focus-visible:tw-outline-none',
        'focus-visible:tw-border-2',
        'focus-visible:!tw-border-primary-focus',
    ];

    return (
        <div className="tw-relative">
            <button
                type="button"
                ref={ref}
                disabled={isDisabled}
                className={cn(...baseClasses, ...stateClasses)}
                {...props}
            >
                <LabelPanel
                    icon={icon}
                    titleOne={titleOne}
                    titleTwo={titleTwo}
                    titleOneHasMaxWidth={titleOneHasMaxWidth}
                    backgroundClassName="tw-bg-white"
                    noPadding={true}
                />

                <span
                    className={cn(
                        'tw-ml-2',
                        'tw-transition-transform',
                        'tw-flex',
                        'tw-items-center',
                        !isOpen && 'tw-rotate-180'
                    )}
                >
                    <Icon disabled={isDisabled} icon={ChevronUpIcon} size="xs"
                        className={cn(
                            'lg-icon-dynamic-chevron',
                            isDisabled ? 'tw-icon-inactive' : 'tw-icon-primary'
                        )} />
                </span>
            </button>
        </div>
    );
});

ButtonDropdown.displayName = 'ButtonDropdown';

export { ButtonDropdown };

